import { ColorToken, COLOR_TOKENS } from 'base/ui/tokens';
import React from 'react';

export function Icon({
  icon: Component,
  color = 'colorBlack',
  size = 16,
}: {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  color?: ColorToken;
  size?: 14 | 16 | 20 | 24 | 28;
}) {
  return (
    <Component
      style={{
        color: COLOR_TOKENS[color],
        width: `${size}px`,
        height: `${size}px`,
      }}
    />
  );
}
